module.exports = '/ng-templates/user/templates/loan-search-selection-modal.tpl.ftl';
